
export enum CampaignType {
    BUY_ONE_GET_ONE_PRODUCT = 'buyOneGetOneProduct',
    BUY_ONE_GET_ONE_DIFFERENT_PRODUCT = 'buyOneGetOneDifferentProduct',
    GLOBAL_PRODUCT_DISCOUNT_AFTER_THRESHOLD = 'globalProductDiscountAfterThreshold',
    PRODUCT_DISCOUNT = 'productDiscount',
    PRODUCT_DISCOUNT_AFTER_THRESHOLD = 'productDiscountAfterThreshold',
    FREE_DELIVERY_AFTER_THRESHOLD = 'freeDeliveryAfterThreshold',
    FIXED_AMOUNT_DISCOUNT_AFTER_THRESHOLD = 'fixedAmountDiscountAfterThreshold',
    BUY_N_GET_M_CHEAPEST_AT_DISCOUNT = 'buyNGetMCheapestAtDiscount'
}

export interface CampaignItem {
    id: CampaignType;
    title: string;
    description: string;
    image: string;
    inputText?: string;
    inputDescription?: string;
    valueType?: string
}

/** Display label for the Buy N Get M campaign — single source for the card title and the type label. */
const PROMO_COMBO_LABEL = 'Promo Combo';

export const CAMPAIGN_ITEMS: CampaignItem[] = [
    {
        id: CampaignType.BUY_ONE_GET_ONE_PRODUCT,
        title: '1 produit acheté = 1 produit offert',
        description: 'Configurez vos offres 1 produit acheté = 1 produit offert.',
        image: require('../assets/pictures/buyOneGetOneProduct.webp').default
    },
    {
        id: CampaignType.BUY_ONE_GET_ONE_DIFFERENT_PRODUCT,
        title: '1 produit acheté = 1 cadeau offert',
        description: 'Configurez vos offres 1 produit acheté = 1 cadeau offert.',
        image: require('../assets/pictures/buyOneGetOneDifferentProduct.webp').default
    },
    {
        id: CampaignType.GLOBAL_PRODUCT_DISCOUNT_AFTER_THRESHOLD,
        title: 'Réductions globales sur la carte',
        description: 'Configurez des réductions globales sur votre carte, lorsque le panier des clients dépasse le montant requis.',
        image: require('../assets/pictures/globalProductDiscountAfterThreshold.webp').default,
        inputText: 'Valeur de la réduction',
        inputDescription: 'Appliquer une réduction sur tous les produits de ',
        valueType: 'percentage'
    },

    {
        id: CampaignType.PRODUCT_DISCOUNT,
        title: 'Produits en réduction',
        description: 'Configurez des produits à prix réduit pour augmenter leur attractivité.',
        image: require('../assets/pictures/productDiscount.webp').default,
        inputText: 'Valeur de la réduction',
        inputDescription: 'Appliquer une réduction sur tous les produits de ',
        valueType: 'percentage'
    },
    {
        id: CampaignType.PRODUCT_DISCOUNT_AFTER_THRESHOLD,
        title: 'Remises produits à débloquer',
        description: 'Configurez des remises produits à débloquer, lorsque le panier des clients dépasse le montant requis.',
        image: require('../assets/pictures/productDiscountAfterThreshold.webp').default,
        inputText: 'Valeur de la réduction',
        inputDescription: 'Appliquer une réduction sur tous les produits de ',
        valueType: 'percentage'
    },
    {
        id: CampaignType.FREE_DELIVERY_AFTER_THRESHOLD,
        title: 'Frais de livraison offerts',
        description: 'Configurez un montant de panier minimum pour offrir les frais de livraison à vos clients.',
        image: require('../assets/pictures/freeDeliveryAfterThreshold.webp').default
    },
    {
        id: CampaignType.FIXED_AMOUNT_DISCOUNT_AFTER_THRESHOLD,
        title: 'Code promotionnel à débloquer',
        description: 'Configurez un montant de panier minimum pour offrir un code promotionnel à vos clients lorsque leur panier dépasse ce montant.',
        image: require('../assets/pictures/fixedAmountDiscountAfterThreshold.webp').default,
        inputText: 'Valeur du code promo',
        inputDescription: 'Appliquer un code promotionnel de',
        valueType: 'cash'

    }
];

export const CAMPAIGN_WITHOUT_PRODUCT_SELECTION = [
    CampaignType.FIXED_AMOUNT_DISCOUNT_AFTER_THRESHOLD,
    CampaignType.FREE_DELIVERY_AFTER_THRESHOLD,
    CampaignType.GLOBAL_PRODUCT_DISCOUNT_AFTER_THRESHOLD
]
export const MARKETING_CAMPAIGN_DATE_CONFLICT = 'MarketingCampaignDateConflict'
export const MARKETING_CAMPAIGN_IS_TOO_SHORT = 'MarketingCampaignIsTooShort'
export const MARKETING_CAMPAIGN_IS_ABOUT_TO_START = 'MarketingCampaignIsAboutToStart'
export const MARKETING_CAMPAIGN_PRODUCT_CONFLICT = 'MarketingCampaignProductConflict'
export const CAMPAIGN_TYPES = {
    buyOneGetOneProduct: '1 produit acheté = 1 produit offert',
    buyOneGetOneDifferentProduct: '1 produit acheté = 1 cadeau offert',
    globalProductDiscountAfterThreshold: 'Réductions globales sur la carte',
    productDiscount: 'Produits en réduction',
    productDiscountAfterThreshold: 'Remises produits à débloquer',
    freeDeliveryAfterThreshold: 'Frais de livraison offerts',
    fixedAmountDiscountAfterThreshold: 'Code promotionnel à débloquer',
    buyNGetMCheapestAtDiscount: PROMO_COMBO_LABEL
}
export const MARKETING_CAMPAIGN_STATUS = {
    IN_PROGRESS: 'inProgress',
    NOT_STARTED: 'notStarted',
    CANCELED: 'canceled',
    COMPLETED: 'completed',
    PENDING: 'pending'
}

export const MARKETING_CAMPAIGN_STATUS_LABEL = {
    canceled: { label: 'Annulée', color: '#ff4861' },
    notStarted: { label: `En attente`, color: 'rgb(107 142 236 / 82%)' },
    inProgress: { label: 'En cours', color: 'rgb(243 164 6 / 88%)' },
    completed: { label: 'Terminée', color: '#4ce1b6' }
};
export const SHOPS_MODAL_TEXT = 'Définissez la liste des restaurants participant à la campagne. Attention à ne pas mélanger les cartes qui n’ont pas les mêmes références produits.'
export const CAMPAIGN_STATUS = ['En cours', 'A venir', 'Terminées'];
export const EXPANDABLE_SECTIONS = {
    LIMIT: 'limit',
    DISCOUNT: 'discount',
    THRESHOLD: 'threshold',
    PRODUCTLIST: 'productList',
    DATES: 'dates',
    HASLIMIT: 'hasLimit',
    ORDER_TYPES: 'orderTypes',
    BUYNGETM_MECHANICS: 'buyNGetMMechanics',
    CAMPAIGN_NAME: 'campaignName',
}
export const TYPES = {
    CASH: 'cash',
    PERCENTAGE: 'percentage'
}
